import { useTranslation } from 'react-i18next';

import WarningModal from '../WarningModal';

type GoBackWarningModalProps = {
   opened: boolean;
   onClose: () => void;
   onConfirm: () => void;
};

const GoBackWarningModal = ({ opened, onClose, onConfirm }: GoBackWarningModalProps) => {
   const { t } = useTranslation();

   return (
      <WarningModal
         heading={t('goBackWarningModal.heading')}
         description={t('goBackWarningModal.description')}
         cancelBtnText={t('goBackWarningModal.cancelBtnText')}
         confirmBtnText={t('goBackWarningModal.confirmBtnText')}
         opened={opened}
         size="620"
         onClose={onClose}
         onConfirm={onConfirm}
      />
   );
};

export default GoBackWarningModal;
